<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title class="primary accent--text title font-weight-thin mb-5">
            {{ formTitle }}
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="modelForm.name"
                  dense
                  outlined
                  type="text"
                  :label="placeholder.name"
                  :rules="[required]"
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="modelForm.description"
                  dense
                  outlined
                  type="text"
                  :label="placeholder.description"
                  :rules="[required]"
                />
              </v-col>
              <v-col cols="12" lg="6" sm="12">
                <v-select
                  v-model="modelForm.status"
                  :items="status"
                  attach
                  chips
                  dense
                  outlined
                  :label="$t('model.page.placeholder.file_status')"
                  multiple
                />
              </v-col>
              <v-col cols="12" lg="6" sm="12">
                <v-text-field
                  v-model="modelForm.version"
                  dense
                  outlined
                  type="number"
                  prefix="ver"
                  maxlength="5"
                  :label="$t('model.page.placeholder.version')"
                  :rules="[required, maxValue(modelForm.version, 99999)]"
                />
              </v-col>
              <v-col cols="12" md="12">
                <template>
                  <v-file-input
                    v-model="modelForm.file" :disabled="isUpdateMode"
                    multiple
                    :label="$t('model.page.placeholder.input')"
                  />
                </template>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-divider class="mb-5" />
        <v-btn
          outlined
          rounded
          :disabled="isLoading || actionButtonDisabled"
          :loading="isLoading"
          color="primary"
          class="mr-3"
          @click="save"
        >
          {{ actionButtonTitle }}
        </v-btn>

        <v-btn
          outlined rounded text :disabled="isLoading"
          @click="cancel"
        >
          {{ $t("generic.button.cancel") }}
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { mapActions } from "vuex";

export default {
  props: {
    formTitle: { type: String, default: ''},
    isUpdateMode: { type: Boolean, default: false },
    model: {
      type: Object,
      default: () => {
        return { }
      },
    },
    placeholder: {
      type: Object,
      default: () => {
        return {
          name: 'Name',
          description:'Description',
        }
      },
    }
  },
  data() {
    return {
      isLoading: false,
      statusModel: {},
      status: [],
      valid: true,
      modelForm: {
        name: "",
        description: "",
        version: 0,
        file: []
      },
    };
  },
  computed: {
    actionButtonTitle() {
      return this.isUpdateMode ? this.$t('generic.button.update') : this.$t('generic.button.upload'); 
    },
    actionButtonDisabled() {
      return !this.valid || !this.modelForm.name || !this.modelForm.description || !this.modelForm.version
    },
  },
  methods: {
    ...mapActions(["uploadBucketFile", "updateoriginalModel", "getoriginalModelByFileName"]),
    updateModel(model) {
      this.modelForm = model
      this.$refs.form.resetValidation()
    },
    async save() {
      if(this.$refs.form.validate()) {
        this.isLoading = true
        this.isUpdateMode ? this.$emit('update') : this.$emit('create')
      }
    },
    cancel() {
      this.$router.push({
        name: "detail",
        params: { id: this.$route.params.id },
      });
    },
  },
};
</script>
